export enum ExpertExperienceType {
	Experience,
	Education,
}
